/** @jsxImportSource @emotion/react */
import { Box } from "@mui/material";
import PropTypes from "prop-types";

const BidLineDayCell = (props) => {
  const getFormattedShiftTime = (shift) => {
    const startTime = shift.start;
    const endTime = shift.end;
    const formattedStartTime = `${startTime?.substring(0, 2)}${startTime?.substring(2)}`;
    const formattedEndTime = `${endTime?.substring(0, 2)}${endTime?.substring(2)}`;
    const formattedShiftTime = `${formattedStartTime} - ${formattedEndTime}`;
    return formattedShiftTime;
  };

  const renderCell = () => {
    const shiftTime = getFormattedShiftTime(props.shift);
    const shiftJobType = props.shift.position;
    const shiftJobAssignment = props.shift.assignment;
    if (props.shift.isOff) {
      return <Box sx={{ whiteSpace: "pre-wrap", textAlign: "left" }}>OFF</Box>;
    } else {
      return (
        <div>
          <Box sx={{ whiteSpace: "pre-wrap", textAlign: "left" }}>{shiftTime + "\n"}</Box>
          <Box
            sx={{
              whiteSpace: "pre-wrap",
              textAlign: "left",
              fontSize: "12px",
              color: "secondary.swaGray4",
              lineHeight: "95%",
            }}
          >
            {shiftJobAssignment ? shiftJobType + ", \n" + shiftJobAssignment : shiftJobType}
          </Box>
        </div>
      );
    }
  };

  return renderCell();
};

BidLineDayCell.propTypes = {
  shift: PropTypes.object.isRequired,
};

export default BidLineDayCell;
